import mainFeatureVideo from './mainFeatureVideo.js';
export default function triggerMainFeature() {
  let isMobile;

  function triggerFeature() {
    const matches = globalThis.matchMedia('(max-width: 890px)').matches;

    if (matches === isMobile) return;

    isMobile = matches;

    if (matches) {
      $('#main-feature').addClass('mobile');
      $('#vimeoDesktop').empty();
      $('#slideshowDesktop').empty();
      mainFeatureVideo('vimeoMobile', vimeoMobileOpts, 'slideshowMobile', slideshowMobileOpts);
    } else {
      $('#main-feature').removeClass('mobile');
      $('#vimeoMobile').empty();
      $('#slideshowMobile').empty();
      mainFeatureVideo('vimeoDesktop', vimeoDesktopOpts, 'slideshowDesktop', slideshowDesktopOpts);
    }
  }

  triggerFeature();

  $(globalThis).on('resize', triggerFeature);
}
